// extracted by mini-css-extract-plugin
module.exports = {"text_hidden":"News_text_hidden__3y4VA"};